import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { ButtonProps } from './Button';

import { Button } from './Button';

const codeString = '<Button variant={variant} onClick={onClictFunction}>{children}</Button>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Buttons/Button',
  component: Button,
  argTypes: {
    variant: {
      options: [
        'primary',
        'secondary',
        'destructive-primary',
        'destructive-secondary',
        'destructive-secondary-transparent',
        'blank',
        'blank-subtle',
        'blank-icon',
      ],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: Button,
    codeString: codeString,
  },
} as Meta<ButtonProps>;

const Template: StoryFn<ButtonProps> = (args) => <Button {...args} />;

const defaultArgs: Partial<ButtonProps> = {
  variant: 'primary',
  disabled: false,
  displayColumn: false,
  onClick: fn(),
};

export const ButtonExample = Template.bind({});
ButtonExample.args = {
  children: 'Click me!',
  ...defaultArgs,
};

export const WithMultipleChildren = Template.bind({});
WithMultipleChildren.args = {
  ...defaultArgs,
  children: (
    <>
      <div>Child 1</div>
      <div>Child 2</div>
    </>
  ),
};
WithMultipleChildren.argTypes = {
  ...WithMultipleChildren.argTypes,
  children: {
    table: {
      disable: true, // Disable children controls for this specific story
    },
  },
};
